import React from "react";
import LegalPage from "../components/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      eyebrow="Legal"
      title="Terms of Service"
      lastUpdated="February 2026"
    >
      <p>
        These Terms of Service (&ldquo;Terms&rdquo;) govern your access to and use of BizPulse AI
        (&ldquo;BizPulse AI&rdquo;, &ldquo;we&rdquo;, &ldquo;our&rdquo;, the &ldquo;Service&rdquo;), available at
        bizpulseai.net and any subdomains. By creating an account, subscribing to a paid plan,
        or otherwise using the Service, you agree to be bound by these Terms.
      </p>

      <h2>1. Accounts</h2>
      <p>
        You must provide accurate and current information when registering. You are responsible for
        maintaining the confidentiality of your credentials and for all activity that occurs under your
        account. You must be at least 18 years old and authorised to bind your organisation, if you are
        registering on its behalf.
      </p>

      <h2>2. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service to send spam, unsolicited communications, or anything unlawful;</li>
        <li>Attempt to reverse engineer, scrape, or interfere with the Service;</li>
        <li>Resell, sublicense, or otherwise commercialise the Service outside your own consulting practice;</li>
        <li>Upload content that infringes third-party rights, including intellectual property and privacy;</li>
        <li>Use the Service to make automated decisions that have legal effects on individuals without appropriate safeguards.</li>
      </ul>

      <h2>3. Subscriptions & Payments</h2>
      <p>
        Paid plans are sold and billed through <strong>Paddle.com Inc.</strong> (&ldquo;Paddle&rdquo;), which
        acts as our merchant of record. Paddle is the legal seller, processes payment, charges applicable
        taxes, and issues invoices and receipts. Your contract for the purchase is with Paddle; your
        contract for the use of the Service is with BizPulse AI.
      </p>
      <p>
        Monthly plans renew automatically until cancelled. Lifetime plans are a one-time payment for
        perpetual access to the features described at the time of purchase. Prices are listed in US
        dollars unless otherwise stated.
      </p>

      <h2>4. Cancellation</h2>
      <p>
        You may cancel a monthly subscription at any time from your dashboard or by contacting
        <a href="mailto:contact@bizpulseai.net"> contact@bizpulseai.net</a>. Cancellation takes effect at
        the end of the current billing period; you retain access until then. Lifetime plans are not
        subject to cancellation but may be refunded in line with our Refund Policy.
      </p>

      <h2>5. Refunds</h2>
      <p>
        Refunds are governed by our <a href="/refund-policy">Refund Policy</a>. In summary, you may request
        a full refund within 14 days of your first paid invoice; renewal charges are non-refundable by
        default but reviewed case by case.
      </p>

      <h2>6. Your Content & Data Ownership</h2>
      <p>
        You retain all rights to the content you upload, the Business Growth Discoveries™ you configure, and the leads
        captured through your unique BizPulse AI link. We claim no ownership of your leads, Discovery
        responses, or branding. You grant us a limited licence to process this content solely to provide
        the Service to you.
      </p>
      <p>
        We may use anonymised, aggregated statistics (no personal data, no consultant-identifiable data)
        to improve the Service and publish industry benchmarks.
      </p>

      <h2>7. AI-Generated Content</h2>
      <p>
        The Service uses third-party large-language models to generate Business Growth Discovery™ questions and
        Executive Growth Reports™. Outputs may contain errors and should not be treated as professional advice.
        You are responsible for reviewing AI-generated content before sharing it with a client.
      </p>

      <h2>8. Service Availability</h2>
      <p>
        We aim to keep the Service available 24/7 but do not guarantee uninterrupted access. We may
        perform maintenance, ship updates, or temporarily suspend the Service for security or capacity
        reasons.
      </p>

      <h2>9. Termination</h2>
      <p>
        We may suspend or terminate your account if you breach these Terms, fail to pay, or use the
        Service in a way that creates legal or reputational risk for BizPulse AI. You may close your
        account at any time by contacting <a href="mailto:contact@bizpulseai.net">contact@bizpulseai.net</a>.
        Upon termination we will delete or anonymise your data in line with our Privacy Policy.
      </p>

      <h2>10. Disclaimer of Warranties</h2>
      <p>
        The Service is provided &ldquo;as is&rdquo; without warranty of any kind, express or implied,
        including warranties of merchantability, fitness for a particular purpose, accuracy of
        AI-generated content, or non-infringement.
      </p>

      <h2>11. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, BizPulse AI shall not be liable for any indirect,
        incidental, consequential, special, or exemplary damages, including loss of revenue, profits,
        data, or goodwill. Our aggregate liability for any claim arising out of or relating to these
        Terms is capped at the greater of (a) the fees you paid us in the twelve months preceding the
        event giving rise to the claim, or (b) USD 100.
      </p>

      <h2>12. Indemnification</h2>
      <p>
        You agree to indemnify and hold BizPulse AI harmless from any claim, loss, or expense arising
        from your breach of these Terms, your use of the Service, or your content.
      </p>

      <h2>13. Changes to the Terms</h2>
      <p>
        We may update these Terms from time to time. Material changes will be notified by email or
        in-app banner at least 14 days before they take effect. Continued use of the Service after the
        effective date constitutes acceptance.
      </p>

      <h2>14. Governing Law & Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of <strong>Sri Lanka</strong>. Any dispute arising out of
        or relating to these Terms shall be resolved exclusively in the competent courts of
        <strong> Colombo, Sri Lanka</strong>.
      </p>

      <h2>15. Contact</h2>
      <p>
        Questions about these Terms? Email{" "}
        <a href="mailto:contact@bizpulseai.net">contact@bizpulseai.net</a>.
      </p>
    </LegalPage>
  );
}
